// extracted by mini-css-extract-plugin
export var modal = "_m7-0";